const config = {
  gateway: {
    host: process.env.REACT_APP_GATEWAY_URL || "http://localhost:8000",
    port: process.env.REACT_APP_GATEWAY_PORT || "",
    path: process.env.REACT_APP_GATEWAY_PATH || ""
  },
  stripe: {
    key:
      process.env.REACT_APP_STRIPE_KEY ||
      "pk_test_h62UGfBrtlacbtsLLzmCBJuT00fWSYJ1cL"
  },
  mapbox: {
    key:
      process.env.REACT_APP_MAPBOX_KEY ||
      "pk.eyJ1IjoiYmp5dXJrb3ZpY2giLCJhIjoiY2plc3I0YzFrMGJ2dDJxcGdiMG13M2xlbiJ9.yiuhpA6MrP6K1syC3DhfaQ"
  }
};

config.gateway.baseUrl = `${config.gateway.host}${config.gateway.port}${config.gateway.path}`;

export default config;
